import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const CustomSelect = ({ moduleValues, setModuleValues, options, label }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        value={moduleValues?.[label] ?? ''}
        label={label}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            [label]: e.target.value,
          }))
        }
      >
        {options.map((opt) => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default CustomSelect